<template>
  <div style="display:grid;max-width: 400px;place-items: stretch;gap:1rem;">
   

    <template>
      <!-- Facebook SDK is ready but the user is not logged in to our app -->
      <!-- <button v-if="!fbRefused" class="button-submit secondary facebook" @click.prevent="loginWithFB">
        !!Fortsätt med Facebook
      </button> -->
        <button v-if="!registerbyemail" class="button-submit secondary facebook" @click.prevent="loginWithFB">
          Använd Facebook
        </button>


        <h3 v-show="!registerbyemail" style="text-align: center;">
          Eller
        </h3>
        <!-- <h3>Registrera dig med epost</h3> -->
      <form v-if="!formError" @submit.prevent="submitForm">
        <FloatLabel v-show="registerbyemail">
          <input v-model="username" type="email" name="email" placeholder="Ange din epost" required autocomplete="email" v-on:keyup.enter="submitForm" @submit.prevent="submitForm">
        </FloatLabel>
        <button v-if="!registerbyemail" class="button-submit secondary" @click.prevent="registerbyemail = !registerbyemail">
          Använd epost
        </button>
        <button v-show="registerbyemail" class="button-submit secondary">
          Fortsätt
        </button>
      </form>
      <div v-if="formError">
        <div style="display:grid;align-items:center;justify-items:center;">
          <EmailAnimation />
          <h3 style="margin-top:20px;">
            Kolla din mail
          </h3>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import FloatLabel from '@/components/FloatLabels.vue'
import { mapGetters } from 'vuex'
import store from '@/store'
import EmailAnimation from '@/components/EmailAnimation.vue'

// import { facebookSDK } from '@/mixins/facebook-sdk.js'

export default {
  components: {
    FloatLabel,
    EmailAnimation
  },
  // mixins: [facebookSDK],
  data() {
    return {
      formError: false,
      username: '',
      referer: 'FBButton',
      registerbyemail: true,
    }
  },
  computed: {
    ...mapGetters(['fbConnected', 'fbSdkReady', 'fbFirstName', 'fbRefused'])
  },
  methods: {

    submitForm() {

      console.log('Submitting from FBButton', this.username)
      if(!this.username){
        alert('Du måste ange en epostadress')
        return false
      }
      this.$store.dispatch('registerEmail', this.username).then(res => {
      }).catch(() => {
        // 409 = email already registered — expected, fall through to password reset
        this.formError = true
        this.$store.dispatch('resetpw', this.username).then(response => {
        }).catch(error => {
          Sentry.captureException(error)
        })
      })
    },
  },

}

// Function to get a cookie by name
function getCookie(name) {
    const nameEQ = name + "=";
    const cookiesArray = document.cookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
        let cookie = cookiesArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}
</script>

<style scoped>

.facebook{
    background: url(/img/fb-white.svg);
    background-color: #3C5A99;
    background-repeat: no-repeat;
    background-size: 30px;
    background-position-y: 50%;
    background-position-x: 25px;
    padding-left:70px;

  background-color: #3C5A99;
}
.facebook:hover{
  background-color: rgb(94, 120, 177);
  /* border: 2px #8b9dc3; */
}

</style>
